import React, { FC, PropsWithChildren } from 'react';

import { BaseStyleEnums, IceRink } from '@nhl/nhl-breakaway-ui';

import { DasherBoardText, GoalVizEvent } from '~/core/enums';

import { PptReplayTeam as Team } from '../../../pptReplayEmbed/types';
import { GameCenterTeam } from '../../types';

import RinkAds from './RinkAds';

type Props = {
    gameId: number;
    homeTeam: GameCenterTeam | Team;
    awayTeam: GameCenterTeam | Team;
    homeTeamDefendingSide?: BaseStyleEnums.Alignments;
    children?: React.ReactNode;
    dasherBoardText?: DasherBoardText;
    eventId?: string | number;
    eventType?: GoalVizEvent;
    period?: number;
};

const Rink: FC<PropsWithChildren<Props>> = ({
    gameId,
    homeTeam,
    awayTeam,
    homeTeamDefendingSide,
    dasherBoardText,
    children,
    eventId,
    eventType = GoalVizEvent.DEFAULT,
    period,
}) => {
    return (
        <IceRink
            awayTeamAbbrev={awayTeam.abbrev}
            homeTeamLogo={homeTeam.logo}
            homeTeamAbbrev={homeTeam.abbrev}
            homeTeamDefendingSide={homeTeamDefendingSide}
        >
            <RinkAds
                gameId={gameId}
                period={period}
                eventType={eventType}
                eventId={eventId}
                dasherBoardText={dasherBoardText}
            />
            {children}
        </IceRink>
    );
};

export default Rink;
